import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

/**
 * ValidationSchema
 */
const searchSchema = z.object({
  workoutId: z.string().optional(),
});

/**
 * Route Configuration
 */
export const Route = createFileRoute(
  '/_private/_dashboard/beneficiaries/$id/_tabs/program/'
)({
  validateSearch: (search) => {
    try {
      // Validate the search using the Zod schema
      return searchSchema.parse(search);
    } catch {
      return {};
    }
  },
});
